import React from 'react';
const BlacklistTokenConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/ip-whitelist',
			component: React.lazy(() => import('./IPWhitelist'))
		}
	]
};

export default BlacklistTokenConfig;
